import Cookies from "js-cookie";

// const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN || 'localhost';
// const COOKIE_SECURE = process.env.NEXT_PUBLIC_COOKIE_SECURE === 'true';

// Function to set the JWT token in cookies
export const setToken = (token) => {
  // Cookies.set('token', token, { expires: 30 }); // Token will expire in 7 days
  const hostname = typeof window !== "undefined" && window.location.hostname;

  let cookieDomain = "";
  let isLocalhost = false;

  if (hostname === "qa-web.devprestigeride.com") {
    cookieDomain = ".devprestigeride.com";
  } else if (hostname === "www.prestigeride.com") {
    cookieDomain = ".prestigeride.com";
  } else {
    isLocalhost = true;
    cookieDomain = undefined; // Do not set domain on localhost
  }

  Cookies.set("token", token, {
    expires: 30,
    path: "/",
    secure: !isLocalhost, // ✅ false on localhost, true elsewhere
    sameSite: isLocalhost ? "Lax" : "None", // ✅ 'None' for cross-domain, 'Lax' for local
    domain: isLocalhost ? undefined : cookieDomain, // ✅ don't set domain on localhost
  });
};

// Function to get the JWT token from cookies
export const getToken = () => Cookies.get("token");

// Function to remove the JWT token from cookies (for logout)
export const removeToken = () => {
  const hostname = typeof window !== "undefined" && window.location.host;

  let cookieDomain = "";
  let isLocalhost = false;

  if (hostname === "qa-web.devprestigeride.com") {
    cookieDomain = ".devprestigeride.com";
  } else if (hostname === "www.prestigeride.com") {
    cookieDomain = ".prestigeride.com";
  } else {
    isLocalhost = true;
  }

  if (typeof window !== "undefined") {
    localStorage.removeItem("token"); // ✅ restore token
  }

  // Cookies.remove('token');
  // ✅ Always try removing from current domain (fallback)
  Cookies.remove("token", {
    path: "/",
  });

  Cookies.remove("reservationType", {
    path: "/",
  });

  // ✅ If not localhost, remove from root domain too
  if (!isLocalhost) {
    Cookies.remove("token", {
      domain: cookieDomain,
      path: "/",
    });
  }

  if (!isLocalhost) {
    Cookies.remove("reservationType", {
      domain: cookieDomain,
      path: "/",
    });
  }
};

// Function to remove all the cookies
export const clearAllCookies = () => {
  const allCookies = Cookies.get(); // Get all cookies as an object
  Object.keys(allCookies).forEach((cookieName) => {
    Cookies.remove(cookieName); // Remove each cookie
  });
};
